export default __webpack_public_path__ + "static/media/header-background2.0c3e47b5.png";